// extracted by mini-css-extract-plugin
export default {"mari-name":"search-mari_mari-name__w2tNz","selected-mari":"search-mari_selected-mari__YUQP9"};